import { useEffect } from 'react'

/* eslint-disable react-hooks/exhaustive-deps */
const useMountEffect = callback => useEffect(callback, [])
/* eslint-enable react-hooks/exhaustive-deps */

export default useMountEffect
